export const slides = [
  {
    title: "Free time tracker plan perfect for startups",
    description:
      "Traqq’s free plan saved our bootstrapped startup. Simple tracker + plus David from customer support set us up with unlimited users = zero headaches",
    signature: "Derek, App Developer",
    rating: 5,
  },
  {
    title: "Privacy-first time tracking app for team members",
    description:
      "We needed an ethical time tracker that doesn’t spy on our team members. With sensitive client data involved, invasive features like screenshots or activity logging were a hard no. Traqq’s exactly what we’ve been searching for with its privacy first approach.",
    signature: "Margo, Social Media Manager",
    rating: 4.5,
  },
  {
    title: "Switched from Toggl Track for better time reporting",
    description:
      "Switched from Toggl last month - best decision ever. Traqq’s auto-timesheets cut my time spent on admin work in half and my clients love the transparency!",
    signature: "Ivan, Freelance Copywriter",
    rating: 4.5,
  },
  {
    title: "Manage billable hours in 5 clicks",
    description:
      "As a solopreneur, Traqq’s billing features are gold. Track billable hours, export reports and invoice clients - all in 5 easy clicks. It’s ethical and efficient as well!",
    signature: "Nadia, Solo Entrepreneur",
    rating: 5,
  },
  {
    title: "Unlimited users for better project management",
    description:
      "We tried five trackers - Traqq stuck. Unlimited users let our agency scale and the productivity metrics help us optimize our daily workflows",
    signature: "Anika, Digital Marketing Lead",
    rating: 4.5,
  },
  {
    title: "Lightweight app for tracking time efficiently",
    description:
      "Forget clunky tools. Traqq’s lightweight time tracker quietly tracks time while I work. Plus, the reports make client check-ins a cakewalk",
    signature: "Jules, SEO Specialist",
    rating: 5,
  },
  {
    title: "Auto-tracking for accurate time entries",
    description:
      "Need accurate timesheets? Traqq’s auto-tracking nails it. I’ve billed 20% more hours just by eliminating guesswork.",
    signature: "Jennie, Freelance Consultant",
    rating: 5,
  },
  {
    title: "No credit card required for time tracking app",
    description:
      "The free trial hooked us. Now we’re paying subscribers - Traqq’s time tracking and productivity tools are that good.",
    signature: "Laura, E-commerce Manager",
    rating: 4.5,
  },
  {
    title: "Time tracking app built for freelance projects",
    description:
      "Traqq feels like it was built for freelancers. Track time, manage invoices and “wow” clients - all without the extra stress. Lifesaver!",
    signature: "Dane, Freelance Videographer",
    rating: 4.5,
  },
  {
    title: "Save hours weekly with automated time reporting",
    description:
      "Why didn’t I switch sooner? Traqq’s automated logs save me on average 4+ hours weekly. More time for the important stuff!",
    signature: "Nia, Content Creator",
    rating: 5,
  },
  {
    title: "Desktop app for smooth project time management",
    description:
      "Traqq’s desktop app is my productivity sidekick. It runs smoothly, never makes my computer lag and has a nice selection of customizable reports that are client-ready in seconds.",
    signature: "Remy, Graphic Designer",
    rating: 5,
  },
  {
    title: "Stellar support for your time tracking app",
    description:
      "Traqq’s customer support is stellar. They answered my setup question in minutes. Oh, and the tool itself? Brilliant.",
    signature: "Owen, Startup COO",
    rating: 5,
  },
  {
    title: "Consistent time tracking for hybrid team members",
    description:
      "Traqq’s perfect for hybrid teams. Office or remote, tracking stays consistent and managers get real-time insights. No more chaos!",
    signature: "Priya, Hybrid Work Coordinator",
    rating: 4.5,
  },
  {
    title: "Ethical time entries for professional services",
    description:
      "As a therapist, billing ethically matters. Traqq’s secure logs and manual entries let me focus on clients, not admin.",
    signature: "Dr. Ellis, Mental Health Professional",
    rating: 4.5,
  },
  {
    title: "Time spent dashboard increases transparency",
    description:
      "Forget spreadsheets! Traqq’s dashboard shows all the right data at a glance. My SEO loves transparency.",
    signature: "Hank, Project Manager",
    rating: 5,
  },
]
